export default "__VITE_ASSET__Bf13EgNk__"